import Skeleton from 'react-loading-skeleton';
import { StringUtils } from '@manifoldxyz/js-ts-utils';
import useMainStore from '@/store/mainStore';
import ScribeIframe from './ScribeIframe';

export default function RedeemMedia() {
  const studioInstance = useMainStore((state) => state.studioInstance);

  if (!studioInstance) {
    return (
      <Skeleton
        height="100%"
        width="100%"
      />
    );
  }

  const animationUrl =
    studioInstance.publicData.asset.animation_preview ||
    studioInstance.publicData.asset.animation_url;

  if (!animationUrl) {
    return (
      <Skeleton
        height="100%"
        width="100%"
      />
    );
  }

  return (
    <div className="m-claim--relative m-claim--size-full">
      <div className={StringUtils.classnames('m-claim--bg-transparent', 'm-claim--p-0')}>
        <ScribeIframe src={animationUrl} />
      </div>
    </div>
  );
}
